import { useQuery, useQueryClient } from '@tanstack/react-query'
import React from 'react'
import { dashStatus } from 'services/apiUsers';

const useGetDashStatus = () => {
  const queryClient = useQueryClient();
  const{isPending: isGetting, isSuccess: isGot, isError, error, data}=useQuery({
    queryKey:['dashStatus'],
    queryFn: dashStatus,
    keepPreviousData:true,
    staleTime: 2 * 60 * 60 * 1000
  })
  return{isGetting, isGot, isError, error, data}
}

export default useGetDashStatus